<div class="card rounded-4 shadow">
  <div class="card-body d-flex flex-column flex-md-row row-gap-3 justify-content-evenly py-md-4">
    @for (category of categories(); track category.title) {
      <app-link-list [links]="category.links" [subtitle]="category.title"></app-link-list>
    }
  </div>
</div>
